<template>
  <div>
    <!-- 返回顶部按钮 -->
    <van-button
      v-show="showBackToTop"
      class="back-to-top-btn"
      type="primary"
      size="small"
      @click="scrollToTop"
      :style="buttonStyle"
    >
      <van-icon name="upgrade" />
    </van-button>

    <!-- <van-icon
      name="upgrade"
      v-if="false"
      v-show="showBackToTop"
      class="back-to-top-btn"
      size="small"
      @click="scrollToTop"
      :style="buttonStyle"
    /> -->
  </div>
</template>

<script>
export default {
  name: "BackToTopCom",
  props: {
    // 显示按钮的滚动距离阈值
    showThreshold: {
      type: Number,
      default: 300
    },
    // 按钮位置样式
    position: {
      type: String,
      default: "bottom-right", // bottom-right, bottom-left, center-right
      validator: value =>
        ["bottom-right", "bottom-left", "center-right"].includes(value)
    },
    // 自定义样式
    customStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showBackToTop: false,
      scrollTop: 0
    };
  },
  computed: {
    buttonStyle() {
      const baseStyle = {
        position: "fixed",
        zIndex: 999,
        borderRadius: "25px",
        width: "80px",
        height: "40px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
        transition: "all 0.3s ease",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "12px",
        whiteSpace: "nowrap",
        ...this.customStyle
      };

      // 根据位置设置样式
      switch (this.position) {
        case "bottom-left":
          return {
            ...baseStyle,
            bottom: "80px",
            left: "20px"
          };
        case "center-right":
          return {
            ...baseStyle,
            top: "50%",
            right: "20px",
            transform: "translateY(-50%)"
          };
        case "bottom-right":
        default:
          return {
            ...baseStyle,
            bottom: "80px",
            right: "20px"
          };
      }
    }
  },
  mounted() {
    this.addScrollListener();
  },
  beforeDestroy() {
    this.removeScrollListener();
  },
  methods: {
    // 添加滚动监听
    addScrollListener() {
      // 监听页面滚动
      window.addEventListener("scroll", this.handleScroll, { passive: true });

      // 监听容器滚动（如果有的话）
      this.$nextTick(() => {
        const containers = document.querySelectorAll(
          '.van-pull-refresh, .van-list, [class*="scroll"]'
        );
        containers.forEach(container => {
          container.addEventListener("scroll", this.handleScroll, {
            passive: true
          });
        });
      });
    },

    // 移除滚动监听
    removeScrollListener() {
      window.removeEventListener("scroll", this.handleScroll);

      const containers = document.querySelectorAll(
        '.van-pull-refresh, .van-list, [class*="scroll"]'
      );
      containers.forEach(container => {
        container.removeEventListener("scroll", this.handleScroll);
      });
    },

    // 处理滚动事件
    handleScroll() {
      // 获取滚动距离
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // 检查是否显示返回顶部按钮
      this.showBackToTop = this.scrollTop > this.showThreshold;
    },

    // 滚动到顶部
    scrollToTop() {
      // 使用平滑滚动
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });

      // 触发自定义事件
      this.$emit("back-to-top");
    }
  }
};
</script>

<style lang="scss" scoped>
.back-to-top-btn {
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }

  .btn-text {
    font-size: 12px;
    line-height: 1;
    margin-left: 4px;
    white-space: nowrap;
  }

  // 动画效果
  &.van-button--primary {
    animation: fadeInUp 0.3s ease;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .back-to-top-btn {
    width: 28px !important;
    height: 28px !important;
    font-size: 30px !important;

    .btn-text {
      font-size: 30px;
      margin-left: 3px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commonCom/BackToTopCom.vue